import type { MethodTile } from "@/components/PaymentModals/MethodTileGroup.vue";
import type { Customer } from "@/typings/customer";

export const METHOD_LABELS: Record<string, string> = {
  payment_method: "On file",
  gpi_card: "New card",
  stax_card: "New card",
  gpi_ach: "ACH",
  stax_ach: "ACH",
  cash: "Cash",
  check: "Check",
  external: "External"
};

export const METHOD_ICONS: Record<string, string> = {
  payment_method: "fa-regular fa-credit-card",
  gpi_card: "fa-regular fa-credit-card",
  stax_card: "fa-regular fa-credit-card",
  gpi_ach: "fa-regular fa-building-columns",
  stax_ach: "fa-regular fa-building-columns",
  cash: "fa-regular fa-money-bill-wave",
  check: "fa-regular fa-money-check",
  external: "fa-regular fa-arrow-up-right-from-square"
};

export function buildMethodTiles(
  paymentMethodsResponse: any[] | null,
  customer: Customer | null
): MethodTile[] {
  return (paymentMethodsResponse || []).map((m: any) => {
    const label = METHOD_LABELS[m.key] ?? m.label ?? m.key;
    const icon = METHOD_ICONS[m.key];
    const disabled = m.key === "payment_method" && !customer?.payment_method;
    return { id: m.key, label, icon, disabled };
  });
}

export function confirmDestinationFor(
  paymentType: string,
  customer: Customer | null
): string {
  if (!paymentType) return "";
  if (paymentType === "payment_method") {
    const pm = customer?.payment_method as any;
    if (pm?.brand && pm?.last4) return `${pm.brand} •••• ${pm.last4}`;
    return "method on file";
  }
  if (paymentType === "gpi_card" || paymentType === "stax_card")
    return "a new card";
  if (paymentType === "gpi_ach" || paymentType === "stax_ach")
    return "ACH transfer";
  if (paymentType === "cash") return "cash";
  if (paymentType === "check") return "check";
  if (paymentType === "external") return "an external processor";
  return "";
}
